import Vue from "vue";
import vuex from "vuex";
Vue.use(vuex);
const store = new vuex.Store({
  state: {
    loginType: sessionStorage.getItem("loginType") || false, //头部导航 注销
    accountType: sessionStorage.getItem("accountType") || 1, //账户中心
    type: sessionStorage.getItem("type") || 0, //互惠操盘
    stockVisited: [],
    klineTime: '15m',
    accessNumber: 0,
    restaurants: [],
    couponStatus: true,
    couponNo: "",
    couponAmount: "",
    qrCodeUrl: "",
    risk_unread_count: 0,
    //代理佣金
  },
  getters: {
    getLoginType: function (state) {
      state.loginType = sessionStorage.getItem("loginType");
      return state.loginType;
    }
  },
  mutations: {
    //格式：类型(名字)+处理函数 //加1
    changeLoginType(state, type) {
      //console.log(state)//state对象
      state.loginType = type;
    },
    couponAmountCheck(state, type) {
      //console.log(state)//state对象
      state.couponAmount = type;
    },
    setRiskUnreadCount(state, count) {
      state.risk_unread_count = Number(count || 0);
    },
    clearRiskUnreadCount(state) {
      state.risk_unread_count = 0;
    },
    couponNoCheck(state, type) {
      //console.log(state)//state对象
      state.couponNo = type;
    },
    qrCodeUrl(state, type) {
      //console.log(state)//state对象
      state.qrCodeUrl = type;
    },
    addStocksVisited(state, value) {
      let stockVisited = state.stockVisited;
      if (stockVisited.length === 0) {
        stockVisited.push(value);
      } else {
        let flag = true;
        for (let i = 0, len = stockVisited.length; i < len; i++) {
          if (stockVisited[i].symbol === value.symbol) {
            flag = false;
            break;
          } else {
            flag = true;
          }
        }
        if (flag) {
          /*if (stockVisited.length >= 10){
            stockVisited.pop();
            stockVisited.unshift(value);
          }else{
            stockVisited.unshift(value);
          }*/
          stockVisited.unshift(value);
        }
      }

    },
    changeStocksVisited(state, value) {
      let stockVisited = state.stockVisited;
      for (let i = 0, len = stockVisited.length; i < len; i++) {
        if (stockVisited[i].symbol === value.symbol) {
          stockVisited[i].trade = value.trade;
          stockVisited[i].changepercent = value.changepercent;
        }
      }
    },
    changeKlineTime(state, value) {
      state.klineTime = value;
    },
    changeAccessNumber(state) {
      state.accessNumber++
    },
    addRestaurants(state, value) {
      state.restaurants = value;
    },
  },
  actions: {
    /* increment({commit}){ commit("INCREMENT") }*/
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js